"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormInputEyeStyled = exports.FormInputEyeChild = exports.FormInputClearStyled = exports.FormInputClearChild = exports.FormInputFieldWrapStyled = exports.FormInputWrapStyled = exports.FormInputRawWrapStyled = exports.FormInputRawStyled = exports.FormInputRawStyles = exports.FormInputStyled = exports.FormInputHiddenStyled = exports.FormInputBasicStyles = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactUforms = require("react-uforms");

var _utils = require("../../../utils");

var _const = require("../const");

var _icon = require("../../icon");

var _const2 = require("../../../const");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormInputChild = function FormInputChild(_ref) {
  var _clearable = _ref.clearable,
      props = _objectWithoutProperties(_ref, ["clearable"]);

  return /*#__PURE__*/_react.default.createElement(_reactUforms.Text, _extends({}, props, {
    hideError: true
  }));
};

var FormInputBasicStyles = (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 0;\n\n  /* Basic styles */\n  ", "\n\n  /* Color variations */\n  ", "\n\n  /* Placeholder customization */\n  ", "\n\n  /* Focus state */\n  ", "\n\n  /* Disabled state */\n  ", "\n"])), _const.formControlBasic, (0, _const.formControlColorVariant)(), _const.formControlPlaceholder, _const.formControlFocusVariant, _const.formControlDisabledVariant);
exports.FormInputBasicStyles = FormInputBasicStyles;
var FormInputHiddenStyled = (0, _utils.styled)('input')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", "px;\n  ", "\n  /* Size variations */\n  ", "\n"])), function (_ref2) {
  var measure = _ref2.measure;
  return _const.FormControlSize[measure].height;
}, FormInputBasicStyles, function (_ref3) {
  var measure = _ref3.measure;
  return (0, _const.formControlSizeVariant)(measure);
});
exports.FormInputHiddenStyled = FormInputHiddenStyled;
var FormInputStyled = (0, _utils.styled)(FormInputChild)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: ", "px;\n  ", "\n  /* Size variations */\n  ", "\n  ", "\n  ", "\n"])), function (_ref4) {
  var measure = _ref4.measure;
  return _const.FormControlSize[measure].height;
}, FormInputBasicStyles, function (_ref5) {
  var measure = _ref5.measure;
  return (0, _const.formControlSizeVariant)(measure);
}, function (_ref6) {
  var clearable = _ref6.clearable;
  return clearable ? 'padding-right: 40px;' : '';
}, function (_ref7) {
  var $variant = _ref7.$variant;
  return $variant === 'line' ? (0, _utils.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          border-top: none !important;\n          border-left: none !important;\n          border-right: none !important;\n          padding-left: 0;\n          padding-right: 0;\n          &:focus {\n            outline: none;\n          }\n        "]))) : '';
});
exports.FormInputStyled = FormInputStyled;
var FormInputRawStyles = (0, _utils.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: ", "px;\n  ", "\n  /* Size variations */\n  ", "\n"])), _const.FormControlSize.md.height, FormInputBasicStyles, (0, _const.formControlSizeVariant)('md'));
exports.FormInputRawStyles = FormInputRawStyles;
var FormInputRawStyled = (0, _utils.styled)('input')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), FormInputRawStyles);
exports.FormInputRawStyled = FormInputRawStyled;
var FormInputRawWrapStyled = (0, _utils.styled)('div')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  input {\n    ", "\n  }\n"])), FormInputRawStyles);
exports.FormInputRawWrapStyled = FormInputRawWrapStyled;

var FormInputWrapChild = function FormInputWrapChild(props) {
  var className = props.className,
      children = props.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, children);
};

var FormInputWrapStyled = (0, _utils.styled)(FormInputWrapChild)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n\n  & > ", " {\n      position: absolute;\n      margin: -11px 0 0;\n      top: 50%;\n      right: 15px;\n      opacity: 0;\n      z-index: -1;\n      transition: 0.3s;\n    }\n"])), function (props) {
  return (0, _const2.spacingStyle)(props);
}, _icon.IconStyled);
exports.FormInputWrapStyled = FormInputWrapStyled;
var FormInputFieldWrapStyled = (0, _utils.styled)('div')(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n"])), function (props) {
  return (0, _const2.spacingStyle)(props);
});
exports.FormInputFieldWrapStyled = FormInputFieldWrapStyled;

var FormInputClearChild = function FormInputClearChild(_ref8) {
  var className = _ref8.className,
      onClick = _ref8.onClick,
      children = _ref8.children;
  return /*#__PURE__*/_react.default.createElement("button", {
    className: className,
    onClick: onClick,
    type: "button",
    tabIndex: -1
  }, children);
};

exports.FormInputClearChild = FormInputClearChild;
var FormInputClearStyled = (0, _utils.styled)(FormInputClearChild)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 22px;\n  height: 22px;\n  background-color: ", ";\n  position: absolute;\n  border: none;\n  padding: 5px;\n  top: 50%;\n  right: 14px;\n  margin: -11px 0 0;\n  line-height: 8px;\n  cursor: pointer;\n  &:hover,\n  &:focus {\n    outline: none;\n    background-color: ", ";\n  }\n"])), _const2.Colors.secondary, _const2.Colors.secondaryLight);
exports.FormInputClearStyled = FormInputClearStyled;

var FormInputEyeChild = function FormInputEyeChild(_ref9) {
  var className = _ref9.className,
      onClick = _ref9.onClick,
      children = _ref9.children;
  return /*#__PURE__*/_react.default.createElement("button", {
    className: className,
    onClick: onClick,
    type: "button",
    tabIndex: -1
  }, children);
};

exports.FormInputEyeChild = FormInputEyeChild;
var FormInputEyeStyled = (0, _utils.styled)(FormInputEyeChild)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: 22px;\n  height: 14px;\n  background-color: ", ";\n  position: absolute;\n  border: none;\n  padding: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 14px;\n  line-height: 8px;\n  cursor: pointer;\n  &:hover,\n  &:focus {\n    outline: none;\n    background-color: ", ";\n  }\n"])), _const2.Colors.transparent, _const2.Colors.transparent);
exports.FormInputEyeStyled = FormInputEyeStyled;